export default __webpack_public_path__ + "static/media/cart5hover.8a3874dd.jpg";